import React, { useCallback, useEffect, useState, Children } from 'react';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { Habit, loadHabits, saveHabits } from '../utils/storage';
import { markComplete } from '../utils/habits';
import { HabitCard } from '../components/HabitCard';
export const Today: React.FC = () => {
  const [habits, setHabits] = useState<Habit[]>(() => loadHabits());
  const [showNudge, setShowNudge] = useState(false);
  const location = useLocation();
  const refreshHabits = useCallback(() => {
    setHabits(loadHabits());
  }, []);
  // Reload habits whenever this route becomes active
  useEffect(() => {
    refreshHabits();
    if (Math.random() < 0.2) {
      setShowNudge(true);
    }
  }, [location.pathname, location.key]);
  // Also reload on window focus (e.g. returning to tab)
  useEffect(() => {
    window.addEventListener('focus', refreshHabits);
    return () => window.removeEventListener('focus', refreshHabits);
  }, [refreshHabits]);
  const handleComplete = (id: string) => {
    const updatedHabits = habits.map(h => h.id === id ? markComplete(h) : h);
    setHabits(updatedHabits);
    saveHabits(updatedHabits);
  };
  const handleDelete = (id: string) => {
    const updatedHabits = habits.filter(h => h.id !== id);
    setHabits(updatedHabits);
    saveHabits(updatedHabits);
  };
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0
    }
  };
  return <div className="pb-24 pt-8 px-6 max-w-md mx-auto min-h-screen" data-id="element-75">
      <header className="mb-8" data-id="element-76">
        <h1 className="text-3xl font-semibold text-gray-900 mb-2" data-id="element-77">Today</h1>
        <p className="text-gray-500" data-id="element-78">
          Every action is a vote for the type of person you wish to become.
        </p>
      </header>

      {habits.length === 0 ? <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="flex flex-col items-center justify-center py-16 text-center" data-id="element-79">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4" data-id="element-80">
            <Plus className="text-gray-400" size={32} data-id="element-81" />
          </div>
          <h2 className="text-xl font-medium text-gray-900 mb-2" data-id="element-82">
            Start small
          </h2>
          <p className="text-gray-500 mb-8 max-w-[250px]" data-id="element-83">
            Add a simple, 2-minute habit to begin building your new identity.
          </p>
          <Link to="/add" className="bg-gray-900 text-white px-6 py-3 rounded-full font-medium hover:bg-gray-800 transition-colors" data-id="element-84">
            Create first habit
          </Link>
        </motion.div> : <motion.div variants={container} initial="hidden" animate="show" className="space-y-4" data-id="element-85">
          {habits.map(habit => <motion.div key={habit.id} variants={item} data-id="element-86">
              <HabitCard habit={habit} onComplete={handleComplete} onDelete={handleDelete} data-id="element-87" />
            </motion.div>)}

          {showNudge && habits.length > 0 && <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1
      }} className="text-center text-sm text-gray-400 mt-8 italic" data-id="element-88">
              Consistency matters more than perfection.
            </motion.p>}
        </motion.div>}
    </div>;
};